import classNames from 'classnames';
import React from 'react';
import { Button } from '../button';
import { Modal, ModalProps } from '../modal/modal';
import { DialogContextProvider, useDialogContext } from './dialog-context-provider';
import {
  AirtameVariants,
  useVariantContext,
  VariantContextProvider,
} from './variant-context-provider';

export type DialogProps = ModalProps & {
  /** @deprecated Please use the <DialogFooter> and <Button> components. */
  hideCancelButton?: boolean;
  /** @deprecated Please use the <DialogFooter> and <DialogConfirmButton> components */
  confirmButtonLabel?: React.ReactNode;
  /** @deprecated Please use the <DialogFooter> and <Button> components. */
  cancelButtonLabel?: React.ReactNode;
  /** @deprecated Please use the <DialogFooter> and <DialogConfirmButton> components */
  confirmButtonType?: 'primary' | 'secondary' | 'danger';
  /** @deprecated Please use the <DialogFooter> and <DialogConfirmButton> components */
  onConfirm?: () => void;
  /** @deprecated Please use the <DialogFooter> and <Button> components */
  onCancel?: () => void;
  variant?: AirtameVariants;
  fullScreen?: boolean;
};

const LegacyDialog = (props: Omit<DialogProps, 'variant'>): React.ReactElement => {
  const {
    confirmButtonLabel = 'Confirm',
    cancelButtonLabel = 'Cancel',
    confirmButtonType = 'danger',
    rootElementId = 'airtame-dialog-root',
    hideCancelButton = false,
    className,
    children,
    onConfirm,
    onCancel,
    fullScreen,
    ...modalProps
  } = props;

  const { legacy } = useDialogContext();
  const { variant } = useVariantContext();

  const dialogClassName = classNames(
    'airtame-dialog',
    className,
    `airtame-dialog--variant-${variant}`,
    {
      'airtame-dialog--legacy': legacy,
      'airtame-dialog--fullscreen': fullScreen,
    }
  );

  return (
    <Modal rootElementId={rootElementId} className={dialogClassName} {...modalProps}>
      <>
        {children}
        {legacy && (
          <div className="airtame-dialog__footer">
            {!hideCancelButton && (
              <Button
                className="airtame-dialog__cancel"
                size="large"
                buttonType="secondary"
                onClick={onCancel}
              >
                {cancelButtonLabel}
              </Button>
            )}
            <Button
              className="airtame-dialog__confirm"
              size="large"
              buttonType={confirmButtonType}
              onClick={onConfirm}
            >
              {confirmButtonLabel}
            </Button>
          </div>
        )}
      </>
    </Modal>
  );
};

export const Dialog = ({ variant = 'default', ...restProps }: DialogProps) => {
  return (
    <VariantContextProvider variant={variant}>
      <DialogContextProvider>
        <LegacyDialog {...restProps} />
      </DialogContextProvider>
    </VariantContextProvider>
  );
};

Dialog.displayName = 'Dialog';
